/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { SignInPageService } from '@pages/SignIn/services';
import { AppNavigatorService } from '@/AppNavigator';
import toast from 'react-hot-toast';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(AppNavigatorService.name);
};

export const signInUser = async (context: any, event: any) => {
  const currentState = 'SIGN_IN_USER';
  const method = 'signIn';
  const storageSrv = StorageModule.getInstance();

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      context['SIGN_IN_USER'].payload = event?.payload;
      const srv = getSrv();
      const content = await srv.agent.signInUser(event?.payload);

      if (content && content?.accessToken) {
        if (event?.payload?.rememberMe) {
          storageSrv.set('userProfile', content, 'local');
        } else {
          storageSrv.set('userProfile', content, 'session');
        }
        const userProfile = await getAppSrv()?.getContent();
        if (userProfile) {
          storageSrv.set('myProfile', userProfile?.myProfile, 'session');
          return resolve({
            key: 'SIGN_IN_USER_SUCCESS',
            value: {
              ...(content || {}),
            },
          });
        } else {
          const msg = content?.error?.replace('UnauthorizedError:', '');
          log.error(`error in ${method}, msg: ${msg}`);
          toast.error(msg);
          return reject({
            key: 'SIGN_IN_USER_FAILED',
            value: content,
          });
        }
      } else if (content && content?.signInToken) {
        if (event?.payload?.rememberMe) {
          storageSrv.set('userProfile', content, 'local');
        } else {
          storageSrv.set('userProfile', content, 'session');
        }
        const userProfile = await getAppSrv()?.getContent();

        if (userProfile) {
          storageSrv.set('myProfile', userProfile?.myProfile, 'session');
          return resolve({
            key: 'SIGN_IN_USER_SUCCESS',
            value: {
              ...(content || {}),
            },
          });
        } else {
          const msg = content?.error?.replace('UnauthorizedError:', '');
          log.error(`error in ${method}, msg: ${msg}`);
          toast.error(msg);
          return reject({
            key: 'SIGN_IN_USER_FAILED',
            value: content,
          });
        }
      } else {
        const msg = content?.error?.replace('UnauthorizedError:', '');
        log.error(`error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'SIGN_IN_USER_FAILED',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err}`);
      let _msg = err?.replace('UnauthorizedError:', '');
      toast.error(_msg);
      return reject({
        key: 'SIGN_IN_USER_FAILED',
        value: _msg,
      });
    }
  });
};
